import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { MaterialModule } from './modules/material/material.module';
import { ApexChartsModule } from './modules/apexcharts/apexcharts.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './routes/home/home.component';
import { AuthGuard } from './auth.guard';
import { AuthInterceptor } from './auth.interceptor';
import { CredentialsInterceptor } from './credentials.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DialogComponent } from './components/dialog/dialog.component';
import { DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { CpfPipe } from './modules/pipe/cpf.pipe';
import { ListRegrasComponent } from './routes/regras/list/list-regras.component';
import { ListBancosComponent } from './routes/bancos/list/list-bancos.component';
import { ListUsuariosComponent } from './routes/usuarios/list/list-usuarios.component';
import { CreateUsuarioComponent } from './routes/usuarios/create/create-usuario.component';
import { EditUsuarioComponent } from './routes/usuarios/edit/edit-usuario.component';
import { ListControleFinancasComponent } from './routes/controle-financas/list/list-controle-financas.component';
import { EditControleFinancasComponent } from './routes/controle-financas/edit/edit-controle-financas.component';
import { ListControleFinancaMovimentosComponent } from './routes/controle-financas/list-movimentos/list-controle-financa-movimentos.component';
import { DialogTextValueComponent } from './components/dialog-text-value/dialog-text-value.component';
import { DialogAdicionarAnoComponent } from './components/dialog-adicionar-ano/dialog-adicionar-ano.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { ListUsuarioRegrasComponent } from './routes/usuario-regras/list/list-usuario-regras.component';
import { ListUsuarioTokensComponent } from './routes/usuario-tokens/list/list-usuario-tokens.component';
import { DialogTokenGeradoComponent } from './components/dialog-token-gerado/dialog-token-gerado.component';
import { DialogUsuarioTokenRegrasComponent } from './components/dialog-usuario-token-regras/dialog-usuario-token-regras.component';
import { ListVeiculosComponent } from './routes/veiculos/list/list-veiculos.component';
import { CreateVeiculoComponent } from './routes/veiculos/create/create-veiculo.component';
import { EditVeiculoComponent } from './routes/veiculos/edit/edit-veiculo.component';
import { ListPostosComponent } from './routes/postos/list/list-postos.component';
import { ListVeiculoXUsuariosComponent } from './routes/veiculos/list-veiculo-x-usuarios/list-veiculo-x-usuarios.component';
import { ListVeiculosSemUsuarioComponent } from './routes/veiculos/list-veiculos-sem-usuario/list-veiculos-sem-usuario.component';
import { ListFormasPagamentoComponent } from './routes/formas-pagamento/list/list-formas-pagamento.component';
import { DisableInteractionDirective } from './components/disable-interaction.directive';
import { getPortuguesePaginatorIntl } from './components/custom-paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { ChartsExemploComponent } from './components/charts-exemplo/charts-exemplo.component';
import { ListVeiculoAbastecimentosComponent } from './routes/veiculos/list-abastecimentos/list-veiculo-abastecimentos.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DialogControleFinancaMovimentoComponent } from './components/dialog-controle-financa-movimento/dialog-controle-financa-movimento.component';
import { ListControleFinancaMovimentosFiltroComponent } from './routes/controle-financas/list-movimentos-filtro/list-controle-financa-movimentos-filtro.component';
import { DialogImagemComponent } from './components/dialog-imagem/dialog-imagem.component';
import { FieldErrorComponent } from './components/field-error.component';
import { SqlComponent } from './routes/sql/sql.component';
import { CoresComponent } from './routes/cores/cores.component';
import { ColorPickerDialogComponent } from './components/color-picker-dialog/color-picker-dialog.component';
import { ColorPicker } from './components/color-picker/color-picker';
import { ColorSaturationPicker } from './components/color-picker/color-saturation-picker';
import { ColorHueSlider } from './components/color-picker/color-hue-slider';
import { ColorAlphaSlider } from './components/color-picker/color-alpha-slider';
import { ColorInputFields } from './components/color-picker/color-input-fields';
import { ColorInputField } from './components/color-picker/color-input-field';
import { ColorIconButton } from './components/color-picker/color-icon-button';
import { ColorCoordinates } from './components/color-picker/color-coordinates';
import { ConfiguracoesComponent } from './routes/configuracoes/configuracoes.component';
import { DialogSelectUsuarioComponent } from './components/dialog-select-usuario/dialog-select-usuario.component';
import { DialogCsvConfigComponent } from './components/dialog-csv-config/dialog-csv-config.component';
import { ListPadraoImportacaoCartaoComponent } from './routes/padrao-importacao-cartao/list/list-padrao-importacao-cartao.component';
import { ListaDadosComponent } from './components/lista-dados/lista-dados.component';
import { DetectTruncationDirective } from './directives/detect-truncation.directive';
import { PontoEletronicoComponent } from './routes/ponto-eletronico/ponto-eletronico.component';
import { PontoEletronicoFeriadosComponent } from './routes/ponto-eletronico-feriados/ponto-eletronico-feriados.component';
import { PontoEletronicoAgendamentosComponent } from './routes/ponto-eletronico-agendamentos/ponto-eletronico-agendamentos.component';
import { PontoEletronicoCalendarioComponent } from './routes/ponto-eletronico/ponto-eletronico-calendario.component';
import { LembretesComponent } from './routes/lembretes/lembretes.component';
import { LembretesCalendarioDialogComponent } from './routes/lembretes/lembretes-calendario-dialog.component';
import { ControlePesosComponent } from './routes/controle-pesos/controle-pesos.component';
import { DialogMeuPerfilComponent } from './components/dialog-meu-perfil/dialog-meu-perfil.component';
import { DialogFotoPerfilComponent } from './components/dialog-foto-perfil/dialog-foto-perfil.component';
import { DialogPerfilUsuarioComponent } from './components/dialog-perfil-usuario/dialog-perfil-usuario.component';
import { DialogAlterarSenhaComponent } from './components/dialog-alterar-senha/dialog-alterar-senha.component';
import { DialogControlePesosAlturaComponent } from './components/dialog-controle-pesos-altura/dialog-controle-pesos-altura.component';
import { CalendarioComponent } from './components/calendario/calendario.component';
import { TarefasComponent } from './routes/tarefas/tarefas.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DialogTarefaComponent } from './components/dialog-tarefa/dialog-tarefa.component';
import { DialogTarefaEtiquetaComponent } from './components/dialog-tarefa-etiqueta/dialog-tarefa-etiqueta.component';
import { DialogTarefaColunaComponent } from './components/dialog-tarefa-coluna/dialog-tarefa-coluna.component';
import { DialogTarefaQuadroComponent } from './components/dialog-tarefa-quadro/dialog-tarefa-quadro.component';
import { DialogTarefasEtiquetasComponent } from './components/dialog-tarefas-etiquetas/dialog-tarefas-etiquetas.component';

export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ListRegrasComponent,
    ListBancosComponent,
    ListUsuariosComponent,
    ListUsuarioRegrasComponent,
    ListUsuarioTokensComponent,
    DialogTokenGeradoComponent,
    DialogUsuarioTokenRegrasComponent,
    CreateUsuarioComponent,
    EditUsuarioComponent,
    ListControleFinancasComponent,
    EditControleFinancasComponent,
    ListControleFinancaMovimentosComponent,
    ListControleFinancaMovimentosFiltroComponent,
    ListVeiculosComponent,
    DialogComponent,
    DialogTextValueComponent,
    DialogAdicionarAnoComponent,
    CpfPipe,
    CreateVeiculoComponent,
    EditVeiculoComponent,
    ListPostosComponent,
    ListVeiculoXUsuariosComponent,
    ListVeiculosSemUsuarioComponent,
    ListFormasPagamentoComponent,
    DisableInteractionDirective,
    ChartsExemploComponent,
    ListVeiculoAbastecimentosComponent,
    ConfirmDialogComponent,
    DialogControleFinancaMovimentoComponent,
    DialogImagemComponent,
    FieldErrorComponent,
    SqlComponent,
    CoresComponent,
    ColorPickerDialogComponent,
    ColorPicker,
    ColorSaturationPicker,
    ColorHueSlider,
    ColorAlphaSlider,
    ColorInputFields,
    ColorInputField,
    ColorIconButton,
    ColorCoordinates,
    ConfiguracoesComponent,
    DialogSelectUsuarioComponent,
    DialogCsvConfigComponent,
    ListPadraoImportacaoCartaoComponent,
    ListaDadosComponent,
    DetectTruncationDirective,
    PontoEletronicoComponent,
    PontoEletronicoFeriadosComponent,
    PontoEletronicoAgendamentosComponent,
    PontoEletronicoCalendarioComponent,
    LembretesComponent,
    LembretesCalendarioDialogComponent,
    ControlePesosComponent,
    DialogMeuPerfilComponent,
    DialogFotoPerfilComponent,
    DialogPerfilUsuarioComponent,
    DialogAlterarSenhaComponent,
    DialogControlePesosAlturaComponent,
    CalendarioComponent,
    TarefasComponent,
    DialogTarefaComponent,
    DialogTarefaEtiquetaComponent,
    DialogTarefaColunaComponent,
    DialogTarefaQuadroComponent,
    DialogTarefasEtiquetasComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    ApexChartsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatTableModule,
    MatSelectModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatInputModule,
    MatFormFieldModule,
    MatMenuModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    DragDropModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MatPaginatorIntl, useFactory: getPortuguesePaginatorIntl },
    CookieService,
    DatePipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
